// John Eldhose 20190513
import React, { Component } from 'react';
import { Button, CircularProgress, Grid, IconButton, TextField, Typography } from '@material-ui/core';
import { Cancel, Clear, Done, Search, WebAsset } from '@material-ui/icons';
import { resetLoginPage } from '../lib/LoginPage';
import { renewProduct } from '../../Api/renewProduct';
import ProfileAddress from '../lib/ProfileAddress';
import Subscription from '../lib/Subscription';
import Checkout from '../lib/Checkout';

class Renew extends Component {

  state = {
    loading: false,
    products: {},
    serial: '',
    checkout: [],
    profile: null,
    address: null,
    baddress: null
  }
  componentWillMount() {
    resetLoginPage();
  }
  handleSearch = () => {
    const sn = this.state.serial.toUpperCase();
    if(typeof this.state.products[sn] === 'undefined') {
      this.setState({ loading: true });
      renewProduct(sn)
        .then((prod) => {
          if(prod.status === 'true') {
            const products = this.state.products;
            products[sn] = prod.data[sn];
            if(prod.data.price[sn] === null || prod.data.price[sn] === '')
              products[sn]['price'] = 0;
            else
              products[sn]['price'] = prod.data.price[sn];
            this.setState({ serial: sn, products: products, loading: false });
          }
          else {
            const products = this.state.products;
            products[sn] = null;
            this.setState({ products: products, loading: false });
          }
        })
        .catch(() => { this.setState({ loading: false }); })
    }
    else if(sn !== this.state.serial)
      this.setState({ serial: sn });
  }
  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
      e.preventDefault();
    }
  }
  checkoutbtn = (prod) => {
    if(prod.price === 0) {
      return (
        <Typography>
          <a href="http://www.carlsonsw.com/where-to-purchase/dealers/" rel="noopener noreferrer" target="_blank">Contact Sales to Purchase</a>
        </Typography>
      );
    }
    else if(prod.plan === 'Subscription') {
      if(prod.current === 'true') {
        return (
          <Button
            variant='raised'
            color='primary'
            onClick={() => this.handleCheckout('Unsubscribe')}
          >
            <Cancel /> &nbsp; Unsubscribe
          </Button>
        );
      }
      else {
        return (
          <Button
            variant='raised'
            color='primary'
            onClick={() => this.handleCheckout('Subscribe')}
          >
            <Done /> &nbsp; Subscribe
          </Button>
        );
      }
    }
    else {
      if(prod.current === 'true') {
        return (
          <Typography variant='caption'>
            Serial is current.<br />
            No upgrade needed.
          </Typography>
        );
      }
      else {
        return (
          <Button
            variant='raised'
            color='primary'
            onClick={() => this.handleCheckout('Renew/Upgrade')}
          >
            <Done /> &nbsp; Checkout
          </Button>
        );
      }
    }
  }
  handleCheckout = (plan) => {
    const checkout = [{
      plan: plan,
      serial: this.state.serial,
      name: this.state.products[this.state.serial].PRODUCTNAME,
      description: 'Serial: ' + this.state.serial,
      quantity: 1,
      price: this.state.products[this.state.serial].price,
      taxCode: 'DC010500'
    }];
    this.setState({ checkout: checkout });
  }
  content = () => {
    if(this.state.loading === true)
      return <div style={{ paddingTop: '20px' }}><CircularProgress /></div>;
    else if (
      this.state.serial === '' ||
      typeof this.state.products[this.state.serial] === 'undefined'
    )
      return <div style={{ paddingTop: '20px' }} />;
    else if(this.state.products[this.state.serial] == null)
      return (
        <div style={{ paddingTop: '20px' }}>
          <Typography>
            Serial is not eligible to upgrade
          </Typography>
        </div>
      );
    else {
      const prod = this.state.products[this.state.serial];
      return (
        <Grid container style={{ paddingTop: '30px' }}>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className='ShoppingCart'>
            <table width='100%' className='ShoppingCartRow'>
              <tbody>
                <tr>
                  <td>
                    <Typography variant='body2'>
                      <b>{prod.PRODUCTNAME}</b>
                    </Typography>
                    <Typography variant='body1'>
                      Plan type: {prod.plan}
                    </Typography>
                    <Typography variant='body1'>
                      Network: {(prod.NETWORKLM === '1') ? 'Yes' : 'No'}
                    </Typography>
                    <Typography variant='body1'>
                      Modules: {prod.modules}
                    </Typography>
                  </td>
                  <td align='right'>
                    <Typography variant='body1'>
                      {prod['price'].toLocaleString(
                        'en-US', { style: 'currency', currency: 'USD' }
                      )}
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </table>
            <p />
            <div style={{ textAlign: 'left' }}>
              <Button
                color='secondary'
                onClick={() => this.setState({ serial: '' })}
              >
                <Clear /> &nbsp; Clear
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <div className='ShoppingCartTotal'>
            <table width='100%'>
              <tbody>
                <tr>
                  <td><Typography variant='body1'>Subtotal</Typography></td>
                  <td align='right'>
                    <Typography>
                      {prod.price.toLocaleString(
                        'en-US', { style: 'currency', currency: 'USD' }
                      )}
                    </Typography>
                  </td>
                </tr>
                <tr><td colSpan='2'>&nbsp;</td></tr>
                <tr>
                  <td colSpan='2' align='center'>
                    {this.checkoutbtn(prod)}
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <Typography variant='caption'>
              <font size='1' style={{ fontStyle: 'italic' }}>
                All pricing shown in United States Dollar (USD)
              </font>
            </Typography>
            </div>
          </Grid>
        </Grid>
      );
    }
  }

  render() {
    if(this.state.checkout.length > 0) {
/*

        return (
          <Checkout
            checkout={this.state.checkout}
            profile={this.state.profile}
            address={this.state.address}
            baddress={this.state.baddress}
            completed={() => { return (
              <Subscription
                subscription={this.state.checkout[0]}
                back={() => this.setState({ checkout: [] })}
              />
            ); }}
          />
        );
      else if()
        return (
          <Subscription
            paid={true}
            subscription={this.state.checkout[0]}
            back={() => this.setState({ checkout: [] })}
          />
        );
*/
      if(['Subscribe', 'Unsubscribe'].includes(this.state.checkout[0].plan))
        return (
          <Subscription
            subscription={this.state.checkout[0]}
            back={() => this.setState({ checkout: [] })}
          />
        );
      else if(this.state.address === null)
        return (
          <ProfileAddress
            Back={() => this.setState({ checkout: [], address: null })}
            Continue={(p, a, b) => this.setState({ profile: p, address: a, baddress: b })}
          />
        );
      else
        return (
          <Checkout
            checkout={this.state.checkout}
            profile={this.state.profile}
            address={this.state.address}
            baddress={this.state.baddress}
            completed={() => this.setState({ serial: '' })}
          />
        );
    }
    else
      return (
        <div>
          <Typography variant='display1'>
            <center>
              <font color='#385687'>Renew / Upgrade Product</font>
            </center>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <TextField
                style={{ border: '1px solid silver', borderRadius: '5px', boxShadow: '1px 1px 1px 1px #888888' }}
                fullWidth
                autoFocus={true}
                placeholder='Serial Number'
                value={this.state.serial}
                onKeyPress={this.handleEnter}
                onChange={(e) => this.setState({
                  serial: e.target.value, sendStatus: 0
                })}
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <div style={{ backgroundColor: '#ecf0f1', padding: '10px 10px 0px 10px', borderRadius: '5px 0px 0px 5px', margin: '0px 10px 0px 0px' }}>
                      <WebAsset />
                    </div>
                  ),
                  endAdornment: (
                    <div style={{ backgroundColor: '#ecf0f1', borderRadius: '0px 5px 5px 0px' }}>
                      <IconButton onClick={this.handleSearch}>
                        <Search color='primary' />
                      </IconButton>
                    </div>
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
          </Grid>
          {this.content()}
          <Grid container>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <Typography variant='caption' style={{ textAlign: 'justify', padding: '15px 0px 25px 0px' }}>
                This page is used to renew or upgrade a single serial number. You will need a valid email address to use this form. To manage your account and to renew or upgrade multiple serial numbers in your account please gain access to your account by contacting your administrator for your corporate account or by contacting your Carlson sales support or technical support.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
          </Grid>
        </div>
      );
  }
}

export default Renew;



// WEBPACK FOOTER //
// ./src/components/home/Renew.js